module.exports = __webpack_public_path__ + "media/barcelona musica/small_hall-2f8130d2.jpg";